export default __webpack_public_path__ + "static/media/ic-antrian-kosong.ea595256.svg";